import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import NestedHoverMenuItem from '../../nestedHoverMenu/NestedHoverMenuItem'
import NewPlaylistForm from './NewPlaylistForm'
import EntryAddedConfirmation from './EntryAddedConfirmation'
import DuplicateEntryPrompt from './DuplicateEntryPrompt'
import { connect } from 'react-redux'
import { userAuthoredPlaylists } from '../../../redux/selectors/playlists'
class AddToPlaylistModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      view: 'list'
    }

    this.entryInPlaylist = this.entryInPlaylist.bind(this)
  }

  entryInPlaylist (playlist) {
    return this.props.playlistEntries
      ?.filter({
        playlist: playlist.uuid,
        planEntry: this.props.planEntry.id
      })
      .exists()
  }

  getDisplayedView (playlists) {
    switch (this.state.view) {
      case 'list':
        return (
          <div className='playlist-list'>
            <ul className='add-to-playlist-options'>
              <NestedHoverMenuItem
                label='New Playlist'
                underlined
                handleClick={() => {
                  this.setState({ view: 'new-form' })
                }}
              />
            </ul>
            <ul className='add-to-playlist-options'>{playlists}</ul>
          </div>
        )
      case 'new-form':
        return <NewPlaylistForm />
      case 'duplicate':
        return (
          <DuplicateEntryPrompt
            entry={this.props.planEntry}
            playlist={this.playlist}
            onConfirm={() => {
              this.props.onAdd(this.playlist)
              this.setState({ view: 'confirmation' })
            }}
          />
        )
      case 'confirmation':
        return (
          <EntryAddedConfirmation
            entry={this.props.planEntry}
            playlist={this.playlist}
          />
        )
    }
  }

  render () {
    let playlists = this.props.playlists.map((playlist, idx) => (
      <NestedHoverMenuItem
        label={playlist.title}
        marked={this.entryInPlaylist(playlist)}
        handleClick={() => {
          this.playlist = playlist
          if (this.entryInPlaylist(playlist)) {
            this.setState({ view: 'duplicate' })
          } else {
            this.props.onAdd(playlist)
            this.setState({ view: 'confirmation' })
          }
        }}
        key={idx}
      />
    ))

    let page = this.getDisplayedView(playlists)

    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <div className='add-entry-to-playlist-modal'>
          <div className='playlist-options-container'>
            <div className='playlist-options'>{page}</div>
          </div>
        </div>
      </Modal>
    )
  }
}

AddToPlaylistModal.propTypes = {
  show: PropTypes.bool,
  playlists: PropTypes.array,
  planEntry: PropTypes.object,
  playlistEntries: PropTypes.object,
  onHide: PropTypes.func,
  onAdd: PropTypes.func
}

const mapStateToProps = state => {
  return {
    playlists: userAuthoredPlaylists(state)
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    addEntryToPlaylist: () => {}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToPlaylistModal)
